module.exports = __webpack_public_path__ + "static/illustration-3.ed819df8.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/illustration-3.png
// module id = 1022
// module chunks = 2